module.exports = __webpack_public_path__ + "static/media/galerija_2014 (39).016e041d.jpg";